import { TiltifyConfigContext } from "@/context/tiltifyConfigContext.js";
import { useTiltifyConfigState } from "@/hooks/useTiltifyConfig.js";

export function TiltifyConfigProvider({ children }: { children: React.ReactNode }) {
  const value = useTiltifyConfigState();
  return <TiltifyConfigContext.Provider value={value}>{children}</TiltifyConfigContext.Provider>;
}
